import { render, staticRenderFns } from "./radish-add.vue?vue&type=template&id=7a353ea6"
import script from "./radish-add.vue?vue&type=script&lang=js"
export * from "./radish-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports